import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { getLang } from '../i18n';

const API_URL = process.env.REACT_APP_API_URL || '/api';
const ui = (de, en) => (getLang() === 'en' ? en : de);

export default function StripeCheckoutCompletion() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const sessionId = searchParams.get('session_id') || '';

  useEffect(() => {
    let cancelled = false;
    let timer;
    let attempts = 0;

    const resolveCheckout = async () => {
      attempts += 1;
      try {
        const response = await fetch(
          `${API_URL}/customer/stripe-checkout/public/complete?session_id=${encodeURIComponent(sessionId)}`
        );
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          if (response.status === 409 && attempts < 15) {
            timer = window.setTimeout(resolveCheckout, 1000);
            return;
          }
          throw new Error(payload.error || ui('Weiterleitung konnte nicht abgeschlossen werden.', 'Redirect could not be completed.'));
        }
        if (!payload.verification_url) throw new Error(ui('Verifizierungslink fehlt.', 'Verification link is missing.'));
        if (!cancelled) navigate(payload.verification_url, { replace: true });
      } catch (err) {
        if (!cancelled) setError(err.message || ui('Weiterleitung fehlgeschlagen.', 'Redirect failed.'));
      }
    };

    if (!sessionId) {
      setError(ui('Die Stripe-Sitzung fehlt.', 'The Stripe session is missing.'));
    } else {
      resolveCheckout();
    }

    return () => {
      cancelled = true;
      if (timer) window.clearTimeout(timer);
    };
  }, [navigate, sessionId]);

  return (
    <main className="page-shell">
      <div className="brand-header"><div><p className="eyebrow">YourGermanAddress</p><h1>{ui('Vielen Dank für Ihre Buchung', 'Thank you for your order')}</h1></div></div>
      <div className="card">
        {error ? <div className="hint-box">{error}</div> : <p>{ui('Wir bereiten jetzt Ihren persönlichen Zugang vor …', 'We are preparing your personal access now …')}</p>}
        <p>{ui('Aktivieren Sie anschließend Ihren Business Hub und starten Sie Ihre Verifizierung. Ihren persönlichen Zugangslink erhalten Sie zusätzlich per E-Mail.', 'Next, activate your Business Hub and start your verification. You will also receive your personal access link by email.')}</p>
        {error ? <p><Link className="primary-link-button" to="/">{ui('Zur Startseite', 'Back to home')}</Link></p> : null}
      </div>
    </main>
  );
}

export function StripeCheckoutCancelled() {
  return (
    <main className="page-shell">
      <div className="brand-header"><div><p className="eyebrow">YourGermanAddress</p><h1>{ui('Zahlung nicht abgeschlossen', 'Payment not completed')}</h1></div></div>
      <div className="card">
        <p>{ui('Es wurde nichts berechnet. Sie können die Buchung jederzeit erneut starten.', 'You have not been charged. You can restart your order at any time.')}</p>
        <p><Link className="primary-link-button" to="/">{ui('Zurück zur Übersicht', 'Back to overview')}</Link></p>
      </div>
    </main>
  );
}
